import { render, staticRenderFns } from "./TheNumpad.vue?vue&type=template&id=1b01463d&scoped=true"
import script from "./TheNumpad.vue?vue&type=script&lang=js"
export * from "./TheNumpad.vue?vue&type=script&lang=js"
import style0 from "./TheNumpad.vue?vue&type=style&index=0&id=1b01463d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01463d",
  null
  
)

export default component.exports